export const DEFAULT_TEMPLATES: Record<string, string> = {
  reporting: `{{- $details := fromJSON .Details -}}
{
    "blocks": [
        {
            "type": "section",
            "text": {
                "type": "mrkdwn",
                "text": "*Cluster Name:* {{ .Cluster.Name }}\\n {{ $details.slackMessage }}"
            }
        }
        {{- if $details.chartUrl }},
        {
            "type": "image",
            "image_url": "{{$details.chartUrl}}",
            "alt_text": "Anomaly Detection Chart"
        }
        {{- end }}
    ]
}`,
};
